const addTextMagicDomain = (input: string) => {
  const phoneRegex = /\b\d{10}\b(?!@textmagic\.com)/g;
  return input.replace(phoneRegex, (match) => `${match}@textmagic.com`);
};

export default addTextMagicDomain;
